import React, { Component } from 'react';
import { Layout } from '@bit/bit.rendering.constants.layouts';

import { CollapsibleSplitter } from '../../atoms/split-pane/splitter/flavors/collapsible-splitter';
import { TupleSplitPane } from '../../atoms/tuple-split-pane';

import { LayoutProps, LayoutState } from './homepage-template';

import styles from './homepage-template.module.scss';

export class MobileTemplate extends Component<LayoutProps, LayoutState> {
	render() {
		return (
			<div className={styles.pageLayout}>
				<TupleSplitPane
					min={9}
					max={85}
					ratio={62}
					layout={Layout.column}
					Splitter={CollapsibleSplitter}
				>
					<TupleSplitPane
						min={9}
						max={85}
						ratio={38}
						layout={Layout.row}
						Splitter={CollapsibleSplitter}
					>
						{this.props.fileExplorer}
						{this.props.player}
					</TupleSplitPane>
					{this.props.editor}
				</TupleSplitPane>
			</div>
		);
	}
}
